import React, {Component, useContext, useEffect} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonClose, ButtonProceed, ButtonDownload, ButtonCancel, ButtonRemove } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import ContainerTable from '../../../../layouts/containers/container-table';
import { stringToFriendlyDatetime, getDSTLocalTime } from '../../../../lib/helpers/datetime-helpers';
import LabelContainer from '../../../../components/label-container';
import Divider from '../../../../components/divider/divider';

import ButtonModify from '../../../../components/buttons/button-modify';
import meetingsApi from '../../../../lib/meetings/meetings-api';
import PopupContext from '../../../../context/context-popup';

import MediaHelper from '../../../../lib/helpers/media';
import companiesApi from '../../../../lib/companies/companies-api';
import { FormatMonths } from '../../../../lib/helpers';
import PopupsCancelMembership from '../../popups/popups-cancel-membership';

const YourDetails = ({ booker }) => {
    const Item = ({ title, value }) => {
        return (
            <List gap='10px' style={{ flex: '1 0 0' }}>
                <LabelContainer label={title}>
                    { value }
                </LabelContainer>
            </List>
        )
    }

    const Flex = ({ direction, children }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: direction,
                gap: '20px',
            }}>
                { children }
            </div>
        )
    }

    const profile = booker?.billing_profile;

    return (
        <Container>
            <Container.Header>
                <Container.Text color="#FF6933" fontSize="18px">Your Billing Details</Container.Text>
            </Container.Header>

            <Container.Content>
                <Flex direction="column">
                    <Flex direction="row">
                        <Item title="First Name" value={profile?.first_name}/>
                        <Item title="Last Name" value={profile?.last_name}/>
                    </Flex>
                    <Flex direction="row">
                        <Item title="Company" value={profile?.company_name}/>
                    </Flex>
                    <Item title="Email Address" value={profile?.email_address}/>
                    <Flex direction="row">
                        <Item title="Telephone Number" value={profile?.tel_no}/>
                        <Item title="SAP Number" value={profile?.sap_number}/>
                    </Flex>
                </Flex>
            </Container.Content>
        </Container>
    )
}

const TopRight = ({ membership, company }) => {
    const { setPopup } = useContext(PopupContext);

    const cancel = () => {
        setPopup(<PopupsCancelMembership membership={membership} company={company} getMemberships={() => {
            window.location.href = `/mydmc/account/memberships`;
        }}/>);
    }

    return <Row gap="20px">
        <ButtonRemove onClick={cancel}>Cancel</ButtonRemove>
    </Row>
}

const Summary = ({
    membership
}) => {
    const data = []

    data.unshift([
        1,
        membership?.name,
        `£${membership?.monthly_price}`
    ])

    return (
        <ContainerTable
            className="table-white"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

class MembershipView extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            company: null,
        }
    }

    componentDidMount() {
        this.getCompany();
    }

    getCompany() {
        companiesApi.getCompany(window.user.company_id).then(({ data }) => {
            this.setState({ company: data });
        });
    }

    getFeaturedImage() {
        const membership = this.getCurrentMembership();

        const image = membership?.membership?.content?.feature_image?.[0];

        if (image?.file_name === undefined) return '/images/office.png';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    getCurrentMembership() {
        return this.state.company?.company_memberships?.[0];
    }

    render() {
        const featuredImage = this.getFeaturedImage();
        const membership = this.getCurrentMembership();

        return (
            <Layout 
                theme="dark"
                topLeft={<Welcome title={'Current Membership View'} subtitle={membership?.membership?.name}/>}
                topRight={<TopRight company={this.state.company} membership={membership?.membership}/>}
            >
                <MinMaxLayout
                    main={
                        <List gap="40px">
                            <div className="booking-view">
                                <List gap="40px" divider={<Divider/>} className="booking-view__child">
                                    <Container>
                                        <Container.Header>
                                            <Container.Text color="#FF6933" fontSize="18px">Booking Details</Container.Text>
                                        </Container.Header>

                                        <Container.Content> 
                                            <List gap="20px">
                                                <div className="booking-view__image" style={{ backgroundImage: `url('${featuredImage}')` }}></div>

                                                <LabelContainer label='Membership Plan'>
                                                    { membership?.membership?.name }
                                                </LabelContainer>

                                                <LabelContainer label="Renewal">
                                                    every { FormatMonths(membership?.membership?.renewal_interval_month) }
                                                </LabelContainer>

                                                <LabelContainer label='Cost'>
                                                    £{ membership?.membership?.monthly_price }
                                                </LabelContainer>

                                                <LabelContainer label='Whats Included'>
                                                    <ul style={{
                                                        paddingLeft: '20px',
                                                    }}>
                                                        { membership?.membership?.content?.features?.map((feature, index) => {
                                                            return <li key={index}>{ feature ?.name }</li>
                                                        }) }
                                                    </ul>
                                                </LabelContainer>
                                            </List>
                                        </Container.Content>
                                    </Container>

                                    <YourDetails
                                        booker={this.state.company}
                                    />
                                </List>

                                <Container className="booking-view__child">
                                    <Container.Header>
                                        <Container.Text color="#FF6933" fontSize="18px">Your Order</Container.Text>
                                    </Container.Header>

                                    <Container.Content>
                                        <List gap="40px">
                                            <div className="agree-box" style={{ padding: '0px', gap: '0px' }}>
                                                <div class="bac-bar">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="Path_689" data-name="Path 689" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM11,11v6h2V11Zm0-4V9h2V7Z" transform="translate(-2 -2)" fill="#fcfcfc"/>
                                                    </svg>
                                                    
                                                    <b style={{ fontSize: '14px' }}>Payment via BACS only</b>

                                                    <p style={{ fontSize: '14px', marginLeft: '-10px' }}>Setup will be processed via your myDMC account.</p>
                                                </div>

                                                <div className="agree-box__inner">
                                                    <Summary
                                                        membership={membership?.membership}
                                                    />
                                                    <div className="agree-box__content">
                                                        <div className="agree-box__details">
                                                            <div className="agree-box-details__detail">
                                                                <p>Total</p>
                                                                <span>£{ membership?.membership?.monthly_price }</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <Container>
                                                <Container.Header>
                                                    <Container.Text fontSize="18px" color="#FF6933">Booking Information</Container.Text>
                                                </Container.Header>

                                                <Container.Content>
                                                    <Container.Text fontSize="14px" lightThemeColor="#24191F" darkThemeColor="white" html={membership?.membership?.description}></Container.Text>
                                                </Container.Content>
                                            </Container>

                                            <Container>
                                                <Container.Header>
                                                    <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                                </Container.Header>

                                                <Container.Content>
                                                    <Container.Text fontSize="14px" lightThemeColor="#24191F" darkThemeColor="white" style={{ whiteSpace: 'pre' }}>
                                                        +44 (0)1226 720 700

                                                        bookings@barnsleydmc.co.uk

                                                        DMC
                                                        County Way
                                                        Barnsley
                                                        S70 2JW
                                                        UK
                                                    </Container.Text>
                                                </Container.Content>
                                            </Container>
                                        </List>
                                    </Container.Content>
                                </Container>
                            </div>
                        </List>
                    }
                />
            </Layout>    
        )
    }
}

const el = document.getElementById('account-memberships-view');

if (el) {
    ReactDOM.render(<MembershipView id={el.getAttribute('data-id')}/>, el);
}
